import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components'
import Header from '../../components/Header/Header';
import Main from '../../components/Main/Main';
import Card from '../../components/Card/Card';
import Footer from '../../components/Footer/Footer';
import { fontUbuntuLight } from '../../utilities/utilities';

// const Terms = styled.div`
//     max-height: 560px;
//     overflow:auto;
//     padding: 1rem;
// `

// const FlexBox = styled.div`
//     display: flex;
//     flex-direction: column;
//     margin-top: 2rem;
//     color: ${props => props.textColor ? props.textColor : '#0d1b58'};
// `
// const FlexItem = styled.div`
//     flex: 1 1 auto;
//     text-align: ${ props => props.right ? 'right' : 'left' };
//     margin-bottom: 1rem;
// `

// const FAQDescriptionList = styled.dl`
//   color: ${props => props.textColor ? props.textColor : '#0d1b58'};
//   font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
// `

const PolicyTerm = styled.dt`
  color: ${props => props.textColor ? props.textColor : 'inherit'};
  font-size: 1.0625em;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  font-weight: 700;
`

const PolicyDiv = styled.div`
  margin-bottom: 2rem;
  color: ${props => props.textColor ? props.textColor : 'inherit'};
  font-size: 1.0625em;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  font-weight: ${ props => props.bold ? 700 : 500 };
`

// const FAQParagraph = styled.p`
//   margin-bottom: 1rem;
//   color: ${props => props.textColor ? props.textColor : 'inherit'};
//   font-size: 1.0625em;
//   font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
//   font-weight: ${ props => props.bold ? 700 : 500 };
// `

const PolicyParagraph = styled.span`
  color: ${props => props.textColor ? props.textColor : '#inherit'};
  font-size: 1.0625em;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  font-weight: ${ props => props.bold ? 700 : 500 };
  display: ${ props => props.inline ? 'inline-block' : 'block' };
`

const PolicyTitle = styled.ul`
    /* list-style: none; */
    margin-top: 0.5rem;
    margin-left: 1rem;
`;
// const FAQWordListItem = styled.li`
//     font-weight: ${ props => props.bold ? 700 : 500 };
//     margin-bottom:0.5rem;
// `;

const PrivacyPolicyPage = (props) => {
    // let faqs = props.type ? props.appState.faqs[props.type] : props.appState.faqs[props.appState.type];
    let ppList = props.appState.privacypolicy;
    let ppListing = Object.keys(ppList.lists).map((paragraph, index) => {
        let result;
        if(ppList.lists[paragraph].text){
            result = <PolicyTerm><PolicyTitle>{ppList.lists[paragraph].title}<PolicyParagraph>{ppList.lists[paragraph].text}</PolicyParagraph></PolicyTitle></PolicyTerm>;
        } else if(ppList.lists[paragraph].html){
            result = <PolicyTerm><PolicyTitle>{ppList.lists[paragraph].title}<PolicyDiv dangerouslySetInnerHTML={{__html: ppList.lists[paragraph].html}}/></PolicyTitle></PolicyTerm>;
        }
        return result;
    });

    return (
        <Fragment>

            <Helmet>
                {/* props.appState.ui.terms.meta.title */}
                <title>{`Privacy and Policy`}</title>
                <meta name="description" content={`Privacy and Policy`} />
            </Helmet>

            <Header header={props.appState.ui.header} url={props.url}/>
            <Main site={props.appState.ui.site} >
                {/* props.appState.ui.terms.card.titleText */}
                <Card fontFamily={props.appState.ui.faq.card.fontFamily} card={props.appState.ui.faq.card} pageTitle={ppList.title}>
                    <div>
                        {ppListing}
                    </div>
                </Card>
            </Main>
            <Footer footer={props.appState.ui.footer} url={props.url} clientTerms={props.appState.ui.clientTerms} />

        </Fragment>
    );
};

export default PrivacyPolicyPage;


// WEBPACK FOOTER //
// ./src/containers/PrivacyPolicyPage/PrivacyPolicyPage.js